import { useMemo } from 'react';
import type { AirportSwitch, ChatUiFlightOffer, GenUiKey } from '@voll-intelligence/genui-contract';
import {
  CAROUSEL_SLIDE,
  FlightOfferRow as KitFlightOfferRow,
  type FlightOfferRowProps as KitFlightOfferRowProps,
} from '@voll-intelligence/intelligence-ui-kit';
import {
  airportSwitchView,
  FLIGHT_OFFER_PLACES,
  flightOfferCopy,
} from '../../../../shared/ui/flight_offer_copy.js';
import { useGenUiI18n } from '../../../../shared/ui/i18n.js';

export interface FlightOfferRowProps extends Omit<
  KitFlightOfferRowProps<ChatUiFlightOffer>,
  'copy' | 'locale' | 'places' | 'slide' | 'faresCtaLabel' | 'airportSwitch'
> {
  /** Classes do `<li>` que o host da lista impõe: só o slide do carrossel. */
  readonly className?: string;
  /** Rótulo do toggle da escada, pela chave do catálogo. */
  readonly faresCtaLabel?: GenUiKey;
  readonly airportSwitch?: AirportSwitch | null;
}

/**
 * A linha de oferta do kit (#4997) ligada ao que só o genui-kit tem: os textos
 * do catálogo, o cadastro de aeroportos do domain e o desvio de aeroporto do
 * contrato. Sai quando a lista de ofertas mudar para o kit.
 */
export function FlightOfferRow({
  className,
  faresCtaLabel,
  airportSwitch,
  ...props
}: FlightOfferRowProps) {
  const { t, locale } = useGenUiI18n();
  const copy = useMemo(() => flightOfferCopy(locale), [locale]);
  return (
    <KitFlightOfferRow
      {...props}
      slide={className === CAROUSEL_SLIDE}
      faresCtaLabel={faresCtaLabel ? t(faresCtaLabel) : undefined}
      airportSwitch={airportSwitchView(airportSwitch)}
      copy={copy}
      locale={locale}
      places={FLIGHT_OFFER_PLACES}
    />
  );
}
